<template>
  <span v-if="!html" @click.stop="openReport">
    <a href="javascript:void(0);" :style="styleStr" :class="classname" v-if="isSafari" @click="aTagClick(currentHref)" :rel="rel" target="_blank">
      <slot></slot>
    </a>
    <a :href="currentHref" @click.prevent=" return aTagClick(currentHref)" v-else target="_blank" :style="styleStr" :class="classname" :rel="rel">
      <slot></slot>
    </a>
  </span>
  <span v-else @click.stop="openReport">
    <a href="javascript:void(0);" :style="styleStr" :class="classname" v-if="isSafari" @click="aTagClick(currentHref)" :rel="rel" v-html="html" target="_blank"></a>
    <a :href="currentHref" @click.prevent=" return aTagClick(currentHref)" v-else target="_blank" :style="styleStr" :class="classname" :rel="rel" v-html="html"></a>
  </span>
</template>
<script>
import { enterpriseUrl, getPathParam } from '../../common/utils.js'
var isSafari;
var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf('safari') != -1) {
  if (ua.indexOf('chrome') > -1) {
  } else {
    isSafari = true;
  }
}
export default {
  props: ['href', 'rel', 'html', 'classname', 'styleStr', 'from', 'type'],
  data () {
    return {
      isSafari: isSafari,
      currentHref : '',
    };
  },
  watch : {
    href : {
      immediate:true, // 首次监听生效配置
      handler : async function( v, ov ) {
        this.initHref();
      },
    } 
  },
  methods: {
    aTagClick (path) {
      if (__VERSION === 'HQ' ) {
        if (/https?|\./.test(path)) {
          parent.postMessage({ msg: path }, '*');
        }else{
          this.hrefJump(path,getPathParam('company', path))
        }
        // let host = window.location.host
        // let target = `https://ptest.hecom.cn/cusweb/dist/externalx.html?url=${encodeURI(host + path)}&title=${'蜂寻-' + getPathParam('company', path)}`
        // window.top.open(target, '_blank');
      } else {
        this.isDtAppLogin = !!this.getItem('session', 'isDtAppLogin');
        let openFlag = this.isDtAppLogin ? '_self' : '_blank';
        if (/https?|\./.test(path)) { //外面的地址
          window.open(path, openFlag,'noopener=yes,noreferrer=yes');
        } else { //自己的地址
          let Origin = this.getOrigin();
          window.open(Origin + path, openFlag);
        }
      }
      
    },
    openReport () {
      return 1;
    },
    initHref() {
      this.currentHref = this.href;
      //console.log( this.type + '======' + this.currentHref.indexOf( '/report/' ) );
      if( this.type === 'enterpriseInfo' || this.currentHref.indexOf( '/report/' ) != -1 ) {
        this.currentHref = enterpriseUrl( this.href );
      }
    }
  },
};
</script>
<style lang="scss" scoped>
a {
  color: #555;

}
.hq-alink{
  a{
    color: #337ab7;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/global/gemLink.vue